(function () {
  'use strict';

  /**
   * Language Controller
   * Manages the language selector dropdown UI
   */
  angular
    .module('languageControllers', [])
    .controller('LanguageController', Controller);

  Controller.$inject = ['$scope', 'languageService'];

  function Controller($scope, languageService) {
    // Expose available languages to template
    $scope.availableLanguages = languageService.getAvailableLanguages();

    // Current selected language
    $scope.selectedLanguage = languageService.getCurrentLanguage();

    /**
     * Handle language change from dropdown
     * Changes language and reloads the page to apply changes
     *
     * @param {Object} language - Language object with id and label
     */
    $scope.changeLanguage = function(language) {
      // Guard: Prevent change if no language or same language
      if (!language || language.id === $scope.selectedLanguage.id) {
        return;
      }

      // Change language (will reload page)
      languageService.setLanguage(language.id);
    };
  }
})();
